import { Injectable } from "@angular/core";
import { ComponentStore } from '@ngrx/component-store';
import { map } from "rxjs/operators";
import { ProductsLabels } from "src/app/shared/store-mocks/products.store";
import { CustomerStatus } from "src/app/shared/store-mocks/status.store";
import { UniAuthFacade, UniNumberService } from "unifonic-spa-common/src";
import { MessageLogsResponseType } from "../../log-analyser.models";
import { MessageLogsFetchStore } from "../../store/message-logs-fetch.store";
import { MessageLogsFiltersStore } from '../../store/message-logs-filters.store';
import { mapResponseTypeToVisibleColumns } from '../../utils/map-responst-type-to-visible-columns';

type State = {
    selectedItemId: string
}

const initialState: State = {
    selectedItemId: ''
}

@Injectable()
export class MessageLogsTableSmsWhatsappStore extends ComponentStore<State>{
    constructor(
        private messageLogsFetchStore: MessageLogsFetchStore,
        private messageLogsFiltersStore: MessageLogsFiltersStore,
        private uniNumberService: UniNumberService,
        private uniAuthFacade: UniAuthFacade
    ){
        super(initialState)
    }

    //selectors
    readonly selectedItemId$ = this.select(state => state.selectedItemId)

    readonly selectedItem$ = this.select(
        this.messageLogsFetchStore.entities$,
        this.selectedItemId$,
        (entities, selectedItemId) => {
            return entities.find(e => e.id === selectedItemId) || {}
        }
    )

    readonly entities$ = this.select(
        this.messageLogsFetchStore.entities$,
        this.selectedItemId$,
        (entities, selectedItemId) => {
            return entities.map((entity: any) => {
                return {
                    ...entity,
                    date: entity.date?.slice(-1) === 'Z' ? entity.date : entity.date?.split(' ').join('T') + 'Z',
                    active: entity.recordId === selectedItemId,
                    deliveryNotConfirmedTooltip: entity.status === CustomerStatus.DELIVERY_NOT_CONFIRMED,
                    messageRejected: entity.status === CustomerStatus.REJECTED,
                    productLabel: ProductsLabels[entity.product] ? ProductsLabels[entity.product] : entity.product
                }
            })
        }
    )

    readonly isAlaris$ = this.uniAuthFacade.featureFlags$.pipe(
        map((ff) => {
        return ff['2025-q-1-ci-alaris'];
        })
    );
    

    readonly appsNameVisibility$ = this.select(
        this.isAlaris$,
        this.messageLogsFetchStore.responseType$,
        (isAlaris, responseType) => {
        return !isAlaris && responseType === MessageLogsResponseType.Sms
        }
    )



    readonly vm$ = this.select(
        this.entities$,
        this.messageLogsFetchStore.totalCount$,
        this.messageLogsFetchStore.loading$,
        this.messageLogsFetchStore.responseType$,
        this.appsNameVisibility$,
        (entities, totalCount, loading, responseType, appsNameVisibility) => {
            return {
                entities,
                numberOfItems: this.uniNumberService.formatNumber(totalCount),
                totalCount,
                loading,
                displayedColumns: mapResponseTypeToVisibleColumns(responseType, appsNameVisibility),
                typeWhatsapp: responseType === MessageLogsResponseType.Whatsapp,
                typeSms: responseType === MessageLogsResponseType.Sms,
                statusSortingVisibility: responseType === MessageLogsResponseType.Sms,
                appsNameVisibility
            }
        },
        {debounce: true}
    )


    //updaters
    readonly setSelectedItemId = this.updater( (state, selectedItemId: string) => {
        if(state.selectedItemId === selectedItemId) {
            return {...state, selectedItemId: ''}
        }
        return {...state, selectedItemId}
    } )

    readonly resetSelectedItemId = this.updater( (state) => {
        return {...state, selectedItemId: ''}
    } )
}
